import * as enums from "./enums";
import * as utils from "./utils";

const BookingService = {
    enums,
    utils
}

export default BookingService